<template>
  <div>
    <v-dialog ref="dialog" persistent v-model="dialog" max-width="800">
      <v-card rounded="lg" class="cdlg">
        <div class="cdlg__head">
          <div class="cdlg__eyebrow">{{ $t("rearrangeStudent.eyebrow") }}</div>
          <div class="cdlg__title">{{ $t("rearrange.title") }}</div>
          <div class="cdlg__sub">{{ item.name }}</div>
        </div>
        <v-card-text class="cdlg__body">
          <!-- Card 86aknbxkb: alterar uma aula que está quase acontecendo não
               é proibido, mas o professor precisa saber disso antes de
               confirmar -- quem é pego de surpresa é o aluno. -->
          <template v-if="shortNotice">
            <div class="cdlg__choice-label">
              {{ $t("rearrange.shortNoticeLabel") }}
            </div>

            <div class="cdlg__warn">
              <v-icon color="#B25E00" size="20">mdi-alert-outline</v-icon>
              <p class="cdlg__warn-text">{{ shortNoticeMessage }}</p>
            </div>

            <div class="cdlg__swap">
              <div class="cdlg__swap-side">
                <span class="cdlg__swap-role">{{ $t("common.from") }}</span>
                <span class="cdlg__swap-day">{{ shortNoticeFrom.day }}</span>
                <span class="cdlg__swap-time">{{ shortNoticeFrom.time }}</span>
              </div>

              <v-icon class="cdlg__swap-arrow" color="#A826E1"
                >mdi-arrow-right</v-icon
              >

              <div class="cdlg__swap-side cdlg__swap-side--to">
                <span class="cdlg__swap-role">{{ $t("common.to") }}</span>
                <span class="cdlg__swap-day">{{ shortNoticeTo.day }}</span>
                <span class="cdlg__swap-time">{{ shortNoticeTo.time }}</span>
              </div>
            </div>

            <p class="cdlg__swap-note">
              {{ $t("rearrange.shortNoticeNote") }}
            </p>
          </template>

          <!-- Confirmacao da mudanca definitiva: a pergunta e "e esta troca
               mesmo?", entao a tela mostra exatamente os dois lados dela. -->
          <template v-else-if="confirming">
            <div class="cdlg__choice-label">
              {{ $t("rearrange.confirmPermanent") }}
            </div>

            <div class="cdlg__swap">
              <div class="cdlg__swap-side">
                <span class="cdlg__swap-role">{{ $t("common.from") }}</span>
                <span class="cdlg__swap-day">{{ permanentFrom.day }}</span>
                <span class="cdlg__swap-time">{{ permanentFrom.time }}</span>
              </div>

              <v-icon class="cdlg__swap-arrow" color="#A826E1"
                >mdi-arrow-right</v-icon
              >

              <div class="cdlg__swap-side cdlg__swap-side--to">
                <span class="cdlg__swap-role">{{ $t("common.to") }}</span>
                <span class="cdlg__swap-day">{{ permanentTo.day }}</span>
                <span class="cdlg__swap-time">{{ permanentTo.time }}</span>
              </div>
            </div>

            <p class="cdlg__swap-note">
              {{ $t("rearrange.permanentNote") }}
            </p>
            <p class="cdlg__swap-note cdlg__swap-note--dispute">
              {{ $t("rearrange.permanentDispute") }}
            </p>
          </template>

          <template v-else>
            <div class="cdlg__choice-label">{{ $t("rearrange.whatToDo") }}</div>
            <v-row class="d-flex flex-column">
              <v-checkbox
                :label="$t('rearrange.cancelLesson')"
                color="#A826E1"
                v-model="selected"
                value="cancel"
              />
              <v-checkbox
                :label="$t('rearrange.otherSubject')"
                color="#A826E1"
                v-model="selected"
                value="next"
              />
              <v-checkbox
                :label="$t('rearrange.otherDay')"
                color="#A826E1"
                v-model="selected"
                value="other"
              />
              <!-- Card 86aje36nz: a experimental é um encontro único, não tem
                   grade recorrente para alterar "definitivamente". -->
              <v-checkbox
                v-if="!isExperimental"
                :label="$t('rearrange.permanentDay')"
                color="#A826E1"
                v-model="selected"
                value="permanent"
              />
            </v-row>
            <template v-if="canceling">
              <v-row>
                <v-textarea
                  solo
                  name="input-7-1"
                  :label="$t('rearrange.reasonLabel')"
                  :hint="$t('rearrange.reasonHint')"
                  v-model="motivo"
                ></v-textarea>
              </v-row>
              <!-- Card 17trt6jcxy2: o professor decide se o assunto da aula
                   cancelada vai para a próxima (ex.: feriado) ou se segue a
                   grade como está. -->
              <div v-if="!isExperimental" class="cdlg__shift">
                <div class="cdlg__choice-label">
                  {{ $t("rearrange.shiftQuestion") }}
                </div>
                <v-radio-group v-model="shiftSubjects" dense hide-details>
                  <v-radio
                    color="#A826E1"
                    :value="true"
                    :label="$t('rearrange.shiftYes')"
                  />
                  <v-radio
                    color="#A826E1"
                    :value="false"
                    :label="$t('rearrange.shiftNo')"
                  />
                </v-radio-group>
                <p v-if="shiftSubjects" class="cdlg__swap-note">
                  {{ $t("rearrange.shiftNote") }}
                </p>
              </div>
            </template>
            <v-row v-else-if="updateLeasson">
              <v-row dense>
                <v-col class="d-flex align-center justify-center" cols="12">
                  <v-select
                    v-model="searchLevel"
                    :label="$t('rearrange.chooseLevel')"
                    :items="englishLevels"
                    :item-text="`text`"
                    :item-value="`value`"
                  />
                </v-col>
                <v-col
                  class="d-flex align-center justify-center flex-column"
                  cols="12"
                >
                  <page-skeleton
                    v-if="searchLevelLoading"
                    variant="rows"
                    :rows="2"
                  />
                </v-col>
                <v-col class="d-flex align-center justify-center" cols="12">
                  <v-select
                    :label="$t('rearrange.chooseSubject')"
                    :items="newClassSelectContent"
                    :item-text="`title`"
                    :item-value="`id`"
                    v-if="!searchLevelLoading && newClassSelectContent"
                    v-model="newContent"
                  >
                    <template #item="{ item }">
                      <div class="subject-option">
                        <span class="subject-option__index">{{
                          item.position
                        }}</span>
                        <span class="subject-option__title">{{
                          item.title
                        }}</span>
                        <LessonTagChips
                          :category="item.category"
                          :pre="item.pre"
                          :optional="item.optional"
                        />
                      </div>
                    </template>
                  </v-select>
                  <span v-else-if="noContentMessage">{{
                    $t("rearrange.noContent")
                  }}</span>
                </v-col>
              </v-row>
            </v-row>
            <!-- A escolha do horário é a mesma nos dois casos; só muda o que
                 acontece depois de confirmar. -->
            <v-row v-if="picking">
              <v-col v-if="loadingMatch" cols="12">
                <page-skeleton variant="rows" :rows="3" />
              </v-col>
              <v-col
                class="d-flex align-center justify-center flex-column"
                v-else
              >
                <span v-if="selected === 'permanent'" class="cdlg__scope-note">
                  {{ $t("rearrange.permanentScope") }}
                </span>

                <!-- A alteração pontual muda a aula do mesmo jeito e abre o
                     mesmo direito de discordar. Sem este aviso o professor só
                     descobria isso quando a discordância chegava. -->
                <span v-if="selected === 'other'" class="cdlg__scope-note">
                  {{ $t("rearrange.otherScope") }}
                </span>
                <span v-if="currentSlot" class="mb-4">
                  {{
                    $t("rearrangeStudent.currentSlot", {
                      slot: formatCurrentSlot(),
                    })
                  }}
                </span>
                <span v-if="pickerSlots.length === 0">
                  {{ $t("rearrangeStudent.noSlots") }}</span
                >
                <div v-else style="height: 100%; width: 100%">
                  <!-- Card 86aknbxkb: o professor pode remarcar para um
                       horário livre do próprio dia da solicitação. -->
                  <date-picker
                    ref="picker"
                    :horarios="pickerSlots"
                    allow-today
                  />
                </div>
              </v-col>
            </v-row>
          </template>
        </v-card-text>
        <div class="cdlg__actions">
          <v-btn
            text
            class="cdlg__btn"
            color="var(--dk-ink, #231A2E)"
            @click="secondaryAction"
          >
            {{
              !shortNotice && confirming
                ? $t("common.back")
                : $t("common.cancel")
            }}
          </v-btn>
          <v-btn
            depressed
            rounded
            dark
            class="cdlg__btn"
            color="#A826E1"
            :disabled="selected == null"
            @click="late"
          >
            <v-icon left size="18">{{ primaryIcon }}</v-icon>
            {{ primaryLabel }}
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import partnerApi from "@/shared/pitchPartnerApi";
import { format } from "date-fns";
import {
  formatRearrangeSlot,
  normalizeRearrangeResponse,
} from "@/shared/rearrangeOptions";
import { SUBJECT_LEVELS } from "@/shared/classPresentation";
import LessonTagChips from "@/components/connect/course/LessonTagChips.vue";
import { lessonPosition } from "@/shared/courseTiers";
import { languageTag } from "@/plugins/i18n";

// Card 86aknbxkb: abaixo desta antecedência a remarcação ainda acontece, mas
// com aviso -- alinhar com o aluno antes é responsabilidade do professor.
const SHORT_NOTICE_MS = 24 * 60 * 60 * 1000;
export default {
  name: "class-adiar-dialog",
  components: { LessonTagChips },
  props: {
    item: {
      type: Object,
    },
  },
  data: () => {
    return {
      searchLevel: null,
      searchLevelLoading: false,
      loadingMatch: false,
      updateLeasson: false,
      newClassSelectContent: null,
      noContentMessage: false,
      currentSlot: null,
      matched: [],
      selected: null,
      dialog: false,
      postpone: false,
      canceling: false,
      // Etapa de confirmação da mudança definitiva, com o horário já escolhido.
      confirming: false,
      pendingPermanent: null,
      // Etapa do aviso de menos de 24h: guarda o horário escolhido enquanto o
      // professor decide se continua.
      shortNotice: null,
      motivo: "",
      // null até o professor responder: a pergunta é obrigatória.
      shiftSubjects: null,
      newContent: null,
      // Inclui as trilhas à parte (conversação, Instrumental e Outros): ao
      // alterar uma aula, o professor pode trocar o assunto por uma delas.
      englishLevels: SUBJECT_LEVELS,
      date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
    };
  },
  computed: {
    isExperimental() {
      return !!this.item?.isExperimental;
    },
    // "Escolher outro dia" e "Alterar definitivamente" usam o mesmo seletor.
    picking() {
      return this.selected === "other" || this.selected === "permanent";
    },
    // Card 17trt6jcrwx: o horário de uma aula cancelada fica livre só naquele
    // dia. Serve para remarcar, não para mudar o dia da turma de vez.
    pickerSlots() {
      if (this.selected !== "permanent") return this.matched;
      return this.matched.filter((slot) => !slot.freedByCancellation);
    },
    permanentFrom() {
      return this.describeSlot(
        this.currentSlot?.date,
        this.currentSlot?.hour,
        this.currentSlot?.to
      );
    },
    permanentTo() {
      const data = this.pendingPermanent;
      return this.describeSlot(
        data?.selectedDate,
        data?.selectedHour?.hour,
        data?.selectedHour?.to
      );
    },
    shortNoticeFrom() {
      return this.describeSlot(
        this.currentSlot?.date,
        this.currentSlot?.hour,
        this.currentSlot?.to
      );
    },
    shortNoticeTo() {
      const data = this.shortNotice?.data;
      return this.describeSlot(
        data?.selectedDate,
        data?.selectedHour?.hour,
        data?.selectedHour?.to
      );
    },
    // O texto diz qual dos dois lados está apertado: a aula que sai da agenda
    // agora, o horário novo, ou os dois.
    shortNoticeMessage() {
      const recommendation = this.$t("rearrange.recommendation");

      if (!this.shortNotice) return recommendation;

      const { currentSoon, nextSoon } = this.shortNotice;

      if (currentSoon && nextSoon) {
        return this.$t("rearrange.bothSoon", { recommendation });
      }

      if (currentSoon) {
        return this.$t("rearrange.currentSoon", { recommendation });
      }

      return this.$t("rearrange.nextSoon", { recommendation });
    },
    primaryLabel() {
      if (this.shortNotice) return this.$t("common.continue");
      return this.confirming
        ? this.$t("rearrange.yesPermanent")
        : this.$t("common.confirm");
    },
    primaryIcon() {
      return this.shortNotice ? "mdi-arrow-right" : "mdi-check";
    },
  },

  methods: {
    open() {
      this.resetRearrangeState();
      this.dialog = true;
      this.selected = null;
    },
    close() {
      this.dialog = false;
      this.selected = null;
      this.canceling = false;
      this.updateLeasson = false;
      this.confirming = false;
      this.pendingPermanent = null;
      this.shortNotice = null;
      this.resetRearrangeState();
    },
    backToPicker() {
      this.confirming = false;
      this.pendingPermanent = null;
    },
    // Cancelar no aviso não fecha o diálogo: devolve o professor ao seletor,
    // onde ele pode escolher outro horário em vez de desistir da remarcação.
    secondaryAction() {
      if (this.shortNotice) {
        const chosen = this.shortNotice.data;
        this.shortNotice = null;

        // O seletor volta a ser montado agora; sem devolver a escolha o
        // professor teria que remarcar data e horário do zero.
        this.$nextTick(() => {
          if (this.$refs.picker) this.$refs.picker.setData(chosen);
        });
        return;
      }

      if (this.confirming) {
        this.backToPicker();
        return;
      }

      this.close();
    },
    slotStartsAt(date, hour) {
      if (!date || !hour) return null;

      const [year, month, day] = String(date).split("-").map(Number);
      const [hours, minutes] = String(hour).split(":").map(Number);
      const parsed = new Date(
        year,
        month - 1,
        day,
        hours || 0,
        minutes || 0,
        0,
        0
      );

      return Number.isNaN(parsed.getTime()) ? null : parsed;
    },
    // Avisa nos dois sentidos: a aula que sai da agenda em cima da hora e a
    // que entra em cima da hora dão o mesmo problema para o aluno.
    shortNoticeFor(pickerData) {
      const now = Date.now();
      const current = this.slotStartsAt(
        this.currentSlot?.date,
        this.currentSlot?.hour
      );
      const next = this.slotStartsAt(
        pickerData?.selectedDate,
        pickerData?.selectedHour?.hour
      );

      const currentSoon =
        !!current && current.getTime() - now < SHORT_NOTICE_MS;
      const nextSoon = !!next && next.getTime() - now < SHORT_NOTICE_MS;

      if (!currentSoon && !nextSoon) return null;

      return { currentSoon, nextSoon, data: pickerData };
    },
    describeSlot(date, hour, to) {
      if (!date || !hour) return { day: "—", time: "—" };

      const [year, month, day] = String(date).split("-").map(Number);
      const parsed = new Date(year, month - 1, day);
      const valid = !Number.isNaN(parsed.getTime());

      return {
        day: valid
          ? `${this.$t(
              `enums.weekDay.${parsed.getDay()}`
            )}, ${parsed.toLocaleDateString(languageTag())}`
          : String(date),
        time: to ? `${hour} – ${to}` : hour,
      };
    },
    confirm() {
      this.$emit("confirm", this.item);
    },
    formatDate(date) {
      return format(date, this.$t("formats.dateTime"));
    },
    formatCurrentSlot() {
      return formatRearrangeSlot(this.currentSlot);
    },
    resetRearrangeState() {
      this.loadingMatch = false;
      this.shortNotice = null;
      this.currentSlot = null;
      this.matched = [];
    },
    late() {
      const item = Object.assign({}, this.item);
      if (this.selected === "cancel") {
        if (!this.isExperimental && this.shiftSubjects === null) {
          this.$root.$emit("display-alert", {
            text: this.$t("rearrange.answerShift"),
            type: 1,
          });
          return;
        }

        item.motivo = this.motivo;
        item.newDate = this.date;
        item.shiftSubjects = this.shiftSubjects === true;
      } else if (this.selected === "next") {
        if (!this.newContent) {
          this.$root.$emit("display-alert", {
            text: this.$t("rearrange.pickSubject"),
            type: 1,
          });
          return;
        }

        item.data = this.newContent;
      } else if (this.picking) {
        // Já confirmada: segue para o pai com o horário guardado.
        if (this.confirming) {
          item.data = this.pendingPermanent;
          this.$emit("confirm", {
            item,
            action: this.selected,
            motivo: this.motivo,
          });
          this.confirming = false;
          this.pendingPermanent = null;
          return;
        }

        // "Continuar" no aviso de menos de 24h: o horário já foi escolhido e
        // o professor está ciente, então a remarcação segue daqui.
        const acknowledged = this.shortNotice;
        const picker = this.$refs.picker;
        const pickerData = acknowledged
          ? acknowledged.data
          : picker
          ? picker.getData()
          : null;

        if (!pickerData?.selectedDate || !pickerData?.selectedHour) {
          this.$root.$emit("display-alert", {
            text: this.$t("rearrangeStudent.pickDateTime"),
            type: 1,
          });
          return;
        }

        if (!acknowledged) {
          const notice = this.shortNoticeFor(pickerData);

          if (notice) {
            this.shortNotice = notice;
            return;
          }
        }

        this.shortNotice = null;

        // Mudar a grade da turma inteira merece uma pergunta a mais; a
        // reposição pontual segue direto, como sempre foi.
        if (this.selected === "permanent") {
          this.pendingPermanent = pickerData;
          this.confirming = true;
          return;
        }

        item.data = pickerData;
      }

      this.$emit("confirm", {
        item,
        action: this.selected,
        motivo: this.motivo,
      });
    },
  },
  watch: {
    selected: function (value) {
      this.confirming = false;
      this.pendingPermanent = null;
      this.shortNotice = null;

      if (value === "cancel") {
        this.shiftSubjects = null;
        this.canceling = true;
        this.updateLeasson = false;
      } else if (value === "next") {
        this.updateLeasson = true;
        this.canceling = false;
      } else if (value === "other" || value === "permanent") {
        this.updateLeasson = false;
        this.canceling = false;
        this.resetRearrangeState();
        this.loadingMatch = true;

        partnerApi
          .rearrange(this.item.id, this.item.classId)
          .then((res) => {
            const options = normalizeRearrangeResponse(res.data);
            this.currentSlot = options.currentSlot;
            this.matched = options.matches;
          })
          .catch(() => {
            this.$root.$emit("display-alert", {
              text: this.$t("rearrangeStudent.loadSlotsFailed"),
              type: 1,
            });
          })
          .finally(() => {
            this.loadingMatch = false;
          });
      } else {
        this.canceling = false;
        this.resetRearrangeState();
      }
    },
    searchLevel: function (level) {
      this.searchLevelLoading = true;
      this.noContentMessage = false;
      partnerApi
        .getClassContentByLevel(level)
        .then((res) => {
          // Sequência do módulo, numerada (card 86ajw35m1).
          this.newClassSelectContent = res.data.content
            ? res.data.content.map((item, index) => ({
                ...item,
                position: lessonPosition(index),
              }))
            : res.data.content;
          if (!this.newClassSelectContent) this.noContentMessage = true;
          this.searchLevelLoading = false;
        })
        .catch(() => {
          this.searchLevelLoading = false;
        });
    },
  },
};
</script>
<style scoped>
.subject-option {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  min-width: 0;
}
.subject-option__index {
  flex: none;
  min-width: 20px;
  color: var(--dk-faint, #9a96a6);
  font-size: 0.75rem;
  font-variant-numeric: tabular-nums;
}
.subject-option__title {
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.cdlg {
  --accent: var(--dk-grape, #a826e1);
  border-radius: 20px !important;
  color: var(--dk-ink, #231a2e);
}
.cdlg__head {
  padding: 22px 24px 4px;
}
.cdlg__eyebrow {
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--accent);
}
.cdlg__title {
  margin-top: 4px;
  font-size: 1.35rem;
  font-weight: 800;
  line-height: 1.2;
  color: var(--dk-ink, #231a2e);
}
.cdlg__sub {
  margin-top: 6px;
  font-size: 0.88rem;
  color: var(--dk-muted, #6b6472);
  line-height: 1.5;
}
.cdlg__body {
  padding-top: 14px;
  color: var(--dk-ink, #231a2e);
}
.cdlg__shift {
  margin-top: 8px;
}
.cdlg__choice-label {
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--dk-muted, #6b6472);
  margin-bottom: 4px;
}
.cdlg__scope-note {
  max-width: 46ch;
  margin-bottom: 12px;
  font-size: 0.84rem;
  line-height: 1.5;
  color: var(--dk-muted, #6b6472);
  text-align: center;
}

/* Os dois lados da troca, lado a lado: a pergunta é a comparação. */
.cdlg__swap {
  display: flex;
  align-items: stretch;
  gap: 12px;
  margin-top: 12px;
}
.cdlg__swap-side {
  flex: 1 1 0;
  display: flex;
  flex-direction: column;
  padding: 14px 16px;
  border-radius: 14px;
  background: var(--dk-paper, #f7f5fa);
  border: 1px solid rgba(var(--dk-ink-rgb, 35, 26, 46), 0.09);
}
.cdlg__swap-side--to {
  background: rgba(168, 38, 225, 0.07);
  border-color: rgba(168, 38, 225, 0.25);
}
.cdlg__swap-role {
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--dk-muted, #6b6472);
}
.cdlg__swap-day {
  margin-top: 8px;
  font-size: 0.92rem;
  font-weight: 700;
  line-height: 1.3;
  color: var(--dk-ink, #231a2e);
}
.cdlg__swap-time {
  margin-top: 2px;
  font-size: 1.15rem;
  font-weight: 800;
  line-height: 1.25;
  color: var(--dk-ink, #231a2e);
  font-variant-numeric: tabular-nums;
}
.cdlg__swap-arrow {
  align-self: center;
}
.cdlg__swap-note {
  margin: 14px 0 0;
  font-size: 0.84rem;
  line-height: 1.5;
  color: var(--dk-muted, #6b6472);
}

/* O que acontece depois da confirmação merece peso próprio: é a parte que o
   professor costuma descobrir tarde, quando a discordância já chegou. */
/* Aviso de antecedência curta: cor própria porque é alerta, não é a mesma
   informação de apoio das outras notas do diálogo. */
.cdlg__warn {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin-top: 12px;
  padding: 12px 14px;
  border-radius: 12px;
  border: 1px solid rgba(178, 94, 0, 0.25);
  background: rgba(255, 176, 32, 0.12);
}
.cdlg__warn-text {
  margin: 0;
  font-size: 0.88rem;
  line-height: 1.5;
  color: #6b4a12;
}

.cdlg__swap-note--dispute {
  margin-top: 10px;
  padding: 10px 12px;
  border-left: 3px solid var(--dk-grape, #a826e1);
  border-radius: 0 8px 8px 0;
  background: rgba(168, 38, 225, 0.06);
}

@media (max-width: 599px) {
  .cdlg__swap {
    flex-direction: column;
  }
  .cdlg__swap-arrow {
    transform: rotate(90deg);
  }
}

.cdlg__actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  padding: 10px 20px 18px;
}
.cdlg__btn {
  text-transform: none;
  letter-spacing: normal;
  font-weight: 700;
}
</style>
